import type { ToastLevel } from "@observe-tech/mfe-shell-api";

type ToastSink = (msg: string, level: ToastLevel) => void;

let sink: ToastSink | null = null;
const queued: Array<[string, ToastLevel]> = [];

export function setToastSink(fn: ToastSink | null) {
  sink = fn;
  if (fn) {
    while (queued.length) {
      const [msg, level] = queued.shift()!;
      fn(msg, level);
    }
  }
}

export function createNotify() {
  return (msg: string, level: ToastLevel) => {
    if (sink) {
      sink(msg, level);
    } else {
      queued.push([msg, level]);
    }
  };
}
